<template>
  <div class="visualization_div">
    <div class="header"></div>

    <div id="leftVideo" class="leftVideo">
      <span class="txt"
        >当前在线人数：<span style="color: #0dcce1">{{ persion_num }}</span> 人</span
      >
      <div id="videos" class="videos">
        <Preview
          :client="client"
          v-for="(client, index) in clients"
          class="videoList"
          @fullScreenEvent="fullScreenEvent"
          :key="index"
        />
      </div>
    </div>
    <div id="rightVideo" class="rightVideo">
      <img
        src="./close.png"
        style="float: right;margin-right: 12px;margin-top: 10px;z-index: 2"
        @click="closeDialog(1)"
      />
      <video id="dialogVideo" autoplay style="height: 90%;width: 100%" />
    </div>
  </div>
</template>

<script>
  import SkyRTC from './SkyRTC-client.js'
  import Preview from './Preview'
  export default {
    props: ['headertext', 'headericon'],
    components: {
      // left3: () => import("")
      Preview: () => import('./Preview')
    },
    data() {
      return {
        rtc: null,
        disableVoice: null,
        index_num: 1,
        persion_num: 1,
        clients: [
          {
            id: 'me',
            name: '专家',
            stream: null,
            rtc: null,
            muted: true,
            isMy: true
          },
          {
            id: 'me1',
            name: '用户',
            stream: null,
            rtc: null,
            muted: false,
            isMy: false
          },
          {
            id: 'me2',
            name: '用户',
            stream: null,
            rtc: null,
            muted: false,
            isMy: false
          },
          {
            id: 'me3',
            name: '用户',
            stream: null,
            rtc: null,
            muted: false,
            isMy: false
          }
        ],
        videoList: [],
        videoTimer: null,
        dialogVideoId: ''
      }
    },

    methods: {
      // 打开视频通话
      operMellic() {
        this.rtc = SkyRTC()
        this.clients[0].rtc = this.rtc
        let that = this

        //成功创建WebSocket连接
        this.rtc.on('connected', function(socket) {
          //创建本地视频流
          that.rtc.createStream({
            video: true,
            audio: true
          })
        })
        //创建本地视频流成功
        this.rtc.on('stream_created', function(stream) {
          document.getElementById('me').srcObject = stream
          document.getElementById('me').play()
          // 设置本地不播放自己的声音
          document.getElementById('me').volume = 0.0
        })
        //创建本地视频流失败
        this.rtc.on('stream_create_error', () => {
          // alert("打开摄像头和麦克风失败!请检查设备。");
          this.$message.warning('打开摄像头和麦克风失败!请检查当前设备。')
        })
        //接收到其他用户的视频流
        this.rtc.on('pc_add_stream', function(stream, socketId) {
          var id = 'other-' + socketId
          // console.log('index --- '+that.index_num)
          that.persion_num = that.persion_num + 1
          if (that.index_num < 4) {
            // 把that.index_num 之后的删掉

            for (var j = that.index_num; j < 4; j++) {
              var video = document.getElementById('me' + j)
              // console.log('移除用户-'+"me"+j)
              if (video) {
                var videos = document.getElementById('videos')
                videos.removeChild(video.parentNode.parentNode.parentNode)
              }
            }

            that.clients.push({
              id: id,
              stream: stream,
              rtc: null,
              name: socketId.split('-')[0],
              muted: false,
              isMy: false
            })

            // that.clients[that.index_num].id=id;
            // that.clients[that.index_num].stream = stream;

            // 添加到定时任务
            // console.log('添加到定时任务')
            that.videoList.push({ id: id, stream: stream })
            that.index_num = that.index_num + 1
            // 再添加 that.index_num -1 个假的
            for (var j = that.index_num; j < 4; j++) {
              that.clients.push({
                id: 'me' + j,
                stream: null,
                rtc: null,
                name: '用户',
                muted: false,
                isMy: false
              })
            }
          }
        })
        //删除其他用户
        this.rtc.on('remove_peer', function(socketId) {
          var id = 'other-' + socketId
          var video = document.getElementById(id)
          that.persion_num = that.persion_num - 1
          console.log('移除用户-' + id + '  , ' + that.dialogVideoId)
          if (that.dialogVideoId == id) {
            that.closeDialog(1)
          }
          if (video) {
            var videos = document.getElementById('videos')
            videos.removeChild(video.parentNode.parentNode.parentNode)

            // for(var j=0;j<that.clients.length;j++){
            //   if(id == that.clients[j].id){
            //     that.clients.splice(j,1);
            //   }
            // }
            // console.log(that.clients)
            that.index_num = that.index_num - 1
            for (var j = that.index_num; j < 4; j++) {
              var video = document.getElementById('me' + j)
              // console.log('移除用户-'+"me"+j)
              if (video) {
                var videos = document.getElementById('videos')
                videos.removeChild(video.parentNode.parentNode.parentNode)
              }
            }

            for (var j = that.index_num; j < 4; j++) {
              that.clients.push({
                id: 'me' + j,
                stream: null,
                rtc: null,
                name: '用户',
                muted: false,
                isMy: false
              })
            }

            console.log(that.clients)
          }
        })

        //连接WebSocket服务器
        var uuid = (((1 + Math.random()) * 0x1000) | 0).toString(8)
        this.rtc.connect(
          'wss://remote.saftysmartcontrol.com:8443/1997/ws/' + uuid,
          'room3',
          JSON.parse(localStorage.getItem('user')).name + '-' + uuid
        )
      },

      _videoTimer() {
        let that = this
        this.videoTimer = setInterval(() => {
          for (var i = 0; i < that.videoList.length; i++) {
            var element = document.getElementById(that.videoList[i].id)
            if (null != element) {
              that.rtc.attachStream(that.videoList[i].stream, that.videoList[i].id)
              that.videoList.splice(i, 1)
            }
          }
        }, 3000)
      },

      fullScreenEvent(stream, id) {
        this.dialogVideoId = id
        document.getElementById('dialogVideo').srcObject = stream
        document.getElementById('dialogVideo').play()
      },
      closeDialog(v) {
        console.log('关闭视频。。。。。。')
        document.getElementById('dialogVideo').srcObject = null
        document.getElementById('dialogVideo').load()
      }
    },
    mounted() {
      this.operMellic()
      // 打开定时器
      this._videoTimer()
    },
    destroyed() {
      this.rtc.closeMediaStream()
      this.rtc = null
      clearInterval(this.videoTimer)
    }
  }
</script>

<style lang="less" scoped>
  .visualization_div {
    .header {
      height: 50px;
      //background: url("/static/headerbg.png") no-repeat center;
      background-size: 100%;
      background-color: #212745;
      display: flex;
      align-items: center;
      img {
        margin-bottom: 5%;
        width: 0.4rem;
        height: 0.4rem;
      }

      span {
        margin-bottom: 5%;
        font-size: calc(100vw * 16 / 1920);
        background-image: -webkit-linear-gradient(bottom, #29f7f1, #8bc7f7, #f6f7fa);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .txt {
      font-size: 20px;
      color: #ffffff;
      margin-top: 5%;
    }
    .leftVideo {
      margin-top: 5%;
      margin-left: 4%;
      width: 30%;
      height: 70%;
      float: left;
    }
    .rightVideo {
      margin-top: 5%;
      margin-right: 5%;
      width: 60%;
      height: 70%;
      float: right;

      background: url('./bg3.png') no-repeat center;
      background-size: 20%;
      background-color: #212741;
    }
    .videos {
      margin-top: 8%;
      width: 100%;
      height: 100%;
    }
    height: 100%;
    background-color: #191c2f;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/expertGuidance/index.vue